<template>
    <DashboardLayout>
        <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
            <p class="mb-0 main-identifier fw-semibold">Delegation</p>
            <span class="material-symbols-outlined">keyboard_arrow_right</span>
            <p class="mb-0 sub-identifier">Revoke</p>
        </div>

        <div class="d-flex justify-content-center mb-5">

            <div class="form-outer">
                <form @submit.prevent="handleSubmit">
                    <div class="crud-form position-relative">

                        <div class="form-inner mb-2">
                            <div class="form-header d-flex justify-content-between align-items-center">
                                <h1 class="mb-0">Delegation</h1>
                            </div>

                            <div class="form-body">
                                <div v-if="isDataLoaded">
                                    <div v-if="form.errorMessage">
                                        <div class="alert alert-danger mt-3" role="alert">
                                            {{ form.errorMessage }}
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div
                                            class="delegation-section d-flex justify-content-center align-items-stretch w-100">
                                            <!-- Delegator -->
                                            <div class="col mb-2">
                                                <div class="w-100">
                                                    <label for="delegator"
                                                        class="form-label fw-bold ms-2">Delegator</label>
                                                    <input type="text" id="delegator" v-model="form.delegator"
                                                        class="form-control form-view-only-input" readonly>
                                                </div>
                                            </div>
                                            <!-- Delegator Role -->
                                            <div class="col  mb-2">
                                                <div class="w-100">
                                                    <label for="delegatorRole" class="form-label fw-bold ms-2">Delegator
                                                        Role</label>
                                                    <input type="text" id="delegatorRole"
                                                        v-model="form.delegatorRoleName"
                                                        class="form-control form-view-only-input" readonly>
                                                </div>
                                            </div>
                                            <!-- Delegatee -->
                                            <div class="col mb-2">
                                                <div class="w-100">
                                                    <label for="delegatee"
                                                        class="form-label fw-bold ms-2">Delegatee</label>
                                                    <input type="text" id="delegatee" v-model="form.delegatee"
                                                        class="form-control form-view-only-input" readonly>
                                                </div>
                                            </div>
                                            <!-- Delegatee Role -->
                                            <div class="col mb-2">
                                                <div class="w-100">
                                                    <label for="delegateeRole" class="form-label fw-bold ms-2">Delegatee
                                                        Role</label>
                                                    <input type="text" id="delegateeRole"
                                                        v-model="form.delegateeRoleName"
                                                        class="form-control form-view-only-input" readonly>
                                                </div>
                                            </div>
                                            <!-- Date Section -->
                                            <div class="date-section col-md-6 w-100 mb-2">
                                                <!-- Start Date -->
                                                <div class="col">
                                                    <div class="w-100">
                                                        <label for="startDate" class="form-label fw-bold ms-2">Start
                                                            Date</label>
                                                        <input type="date" id="startDate" v-model="form.startDate"
                                                            class="form-control" required>
                                                    </div>
                                                </div>
                                                <!-- End Date -->
                                                <div v-if="form.endDate" class="col">
                                                    <div class="w-100">
                                                        <label for="endDate" class="form-label fw-bold ms-2">End
                                                            Date</label>
                                                        <input type="date" id="endDate" v-model="form.endDate"
                                                            class="form-control" required>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Active Period -->
                                            <div v-if="!form.endDate" class="col mb-2">
                                                <div class="w-100">
                                                    <label for="active" class="form-label fw-bold ms-2">Active
                                                        Period</label>
                                                    <input type="text" id="active" v-model="getActivePeriod"
                                                        class="form-control form-view-only-input" readonly>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex justify-content-end mt-2 mb-3">
                                            <button type="submit" class="btn btn-danger">Revoke Delegation</button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="!isDataLoaded" class="loading-state text-center py-5 position-relative">
                                    <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
                                    <p class="mt-2 mb-0 text-muted">Loading delegation...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import '@/assets/css/dashboard.css'
import axios from 'axios'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import DashboardLayout from '../layout/DashboardLayout.vue'
// import blankAvatar from '@/assets/images/blank-profile-avatar.png'

const isLoading = ref(false);
const isDataLoaded = ref(false);

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const form = ref({
    id: '',
    delegator: '',
    delegatee: '',
    delegatorId: '',
    delegatorRoleName: '',
    delegateeId: '',
    delegateeRoleName: '',
    startDate: '',
    endDate: '',
    statusInd: '',
    imageContent: '',
    errorMessage: '',
    revocable: ''
})

const getActiveDelegation = async () => {
    const token = Cookies.get('auth_token');
    isLoading.value = true;
    try {
        const { data } = await axios.get(`${root_api_url}/auth/delegation/active`, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        console.log('Delegation data:', data);
        form.value.id = data.id;
        form.value.delegator = data.delegator;
        form.value.delegatee = data.delegatee;
        form.value.delegatorId = data.delegatorId;
        form.value.delegatorRoleName = data.delegatorRoleName;
        form.value.delegateeId = data.delegateeId;
        form.value.delegateeRoleName = data.delegateeRoleName;
        form.value.imageContent = data.imageContent;
        form.value.startDate = data.startDate;
        form.value.endDate = data.endDate;
        form.value.statusInd = data.statusInd;
        form.value.errorMessage = data.errorMessage;
        form.value.revocable = data.revocable;
    } catch (error) {
        console.error('Error fetching delegation:', error);
    } finally {
        isLoading.value = false;
        isDataLoaded.value = true;
    }
};

const getActivePeriod = computed(() => {
    const start = new Date(form.value.startDate);
    const now = new Date();

    if (!form.value.startDate || Number.isNaN(start.getTime()) || start > now) {
        return 'Delegation has not started yet';
    }

    const diffTime = now - start;
    const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const months = Math.floor(totalDays / 30);
    const weeks = Math.floor((totalDays % 30) / 7);
    const days = totalDays % 7;

    const parts = [];
    if (months > 0) parts.push(`${months} month${months > 1 ? 's' : ''}`);
    if (weeks > 0) parts.push(`${weeks} week${weeks > 1 ? 's' : ''}`);
    if (days > 0 || parts.length === 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);

    return `Delegation has been active for ${parts.join(', ')}`;
});

const handleSubmit = async (delegationId) => {
    const token = Cookies.get('auth_token');
    isLoading.value = true;

    const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

    try {
        const result = await axios.post(`${root_api_url}/auth/delegation/update/${delegationId}`, form.value, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        })
        console.log('Delegation data:', result.data);
        if (result.status === 200) {
            Swal.fire({
                html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Delegation Revoked Successfully</p> `,
                showConfirmButton: true,
                showCloseButton: true,
                icon: undefined,
            });
        }
        form.value.startDate = ''
    } catch (error) {
        console.error('Error fetching delegation:', error);
        Swal.fire({
            html: `${iconHtmlError} <h1 style="font-weight:600;">Error</h1> <p>Failed to revoke delegation</p> `,
            showConfirmButton: true,
            showCloseButton: true,
            icon: undefined,
        });
    } finally {
        isLoading.value = false;
    }
};

onMounted(async () => {
    document.title = "Revoke Delegation"
    await getActiveDelegation();
});
</script>

<style scoped>
.profile-photo-wrapper {
    position: relative;
}

.photo-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    height: 120px;
    width: 120px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-photo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* PROFILE HEADER */
.profile-header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
}

.profile-photo {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: 3px solid #f1f1f1;
    margin-right: 1.5rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-info {
    text-align: left;
}

.delegation-section {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    /* border: 1px solid #e0e0e0; */
    border-radius: 0px;
}

.duration-section {
    display: flex;
    flex-direction: column;
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0px;
}

.duration-header {
    font-size: 1.25rem;
    color: #333;
    background: #eff3ff;
    padding: 0.5rem 1rem;
}

.date-section {
    display: flex;
    flex-direction: row;
    gap: 1rem;
}

.date-section input {
    background: #f9f9f9;
    font-size: 0.9rem;
    color: #555;
    margin-bottom: 0.25rem;
}
</style>
